module.exports = __webpack_public_path__ + "img/9788996687573.802b5b57.jpg";